import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore } from '@utils/react';

const initialState = {
  selectedTab: "classes"
};
const shareSlice = createSlice({
  name: "course-builder/share",
  initialState,
  reducers: {
    changeTab(state, action) {
      state.selectedTab = action.payload;
    },
    changeSelector(state, action) {
      state.activeSelector = action.payload;
    },
    changeClass(state, action) {
      if (action.payload) {
        state.selectedClass = action.payload;
        state.selectedStudents = undefined;
        state.studentsInClass = undefined;
      }
    },
    applyUsersInClass(state, action) {
      if (state.selectedClass?.id === action.payload.class.id) {
        state.studentsInClass = action.payload.students;
      }
    },
    toggleStudent(state, action) {
      state.selectedStudents ??= [];
      const indexOf = state.selectedStudents.findIndex(it => it.id === action.payload.id);
      if (indexOf !== -1) {
        state.selectedStudents.splice(indexOf, 1);
      } else {
        state.selectedStudents.push(action.payload);
        state.selectedStudents.sort((a, b) => a.name.localeCompare(b.name, "da-DK", {
          numeric: true
        }));
      }
    },
    replaceSelectedStudents(state, action) {
      state.selectedStudents = action.payload;
    },
    toggleCoWorker(state, action) {
      state.selectedCoWorkers ??= [];
      const indexOf = state.selectedCoWorkers.findIndex(it => it.id === action.payload.id);
      if (indexOf !== -1) {
        state.selectedCoWorkers.splice(indexOf, 1);
      } else {
        state.selectedCoWorkers.push(action.payload);
        state.selectedCoWorkers.sort((a, b) => a.name.localeCompare(b.name, "da-DK", {
          numeric: true
        }));
      }
    },
    replaceSelectedCoWorkers(state, action) {
      state.selectedCoWorkers = action.payload;
    },
    reset(state) {
      state.activeSelector = initialState.activeSelector;
      state.selectedClass = initialState.selectedClass;
      state.selectedCoWorkers = initialState.selectedCoWorkers;
      state.selectedStudents = initialState.selectedStudents;
      state.selectedTab = initialState.selectedTab;
      state.studentsInClass = initialState.studentsInClass;
    }
  }
});
const shareStore = createIndependentStore(shareSlice);

export { shareSlice, shareStore };
//# sourceMappingURL=_share-drawer.state.js.map
